import { modalViewed } from '@/rudder-typer';

interface ModalViewedPayload {
  modalName: string;
  productId?: string;
  source?: string;
}

export function sendModalViewed({ modalName, productId, source }: ModalViewedPayload) {
  modalViewed({
    modal_name: modalName,
    product_id: productId,
    source,
  });
}
